import React, { useState } from 'react';
import { toast } from 'react-toastify';

import api from '~/services/api';

import {
  Scroll,
  Container,
  Header,
  Area,
  Button,
  Label,
  Stack,
  Box,
  Footer,
  Form,
  Input,
  Progress,
} from '~/components';

const InformacoesGerais: React.FC = () => {
  const [inLoad, setInLoad] = useState(false);

  const [senhaAual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmacaoNovaSenha, setConfirmacaoNovaSenha] = useState('');

  const alterarMinhaSenha = async () => {
    try {
      setInLoad(true);

      let fd = new FormData();

      fd.append('senhaatual', senhaAual);
      fd.append('novasenha', novaSenha);
      fd.append('confirmacaosenha', confirmacaoNovaSenha);

      const response = await api.post(`minha-senha`, fd);

      const { data } = response;

      if (data) {
        if (data.error) {
          toast.error(data.message);
        } else {
          toast.success(data.message);
        }
      }
      setInLoad(false);
    } catch (e) {
      toast.error(`${(e as Error).message}`);
      setInLoad(false);
    }
  };

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Minha Senha"
            subtitle="Altere sua senha de acesso"
          />

          <Area>
            <Form>
              <Stack>
                <Label
                  number="1"
                  label="Senha Atual"
                  subtitle="Informe a senha atual"
                  status={!!senhaAual}
                />
                <Box>
                  <Input
                    type="password"
                    placeholder="Senha atual..."
                    value={senhaAual}
                    onChange={e => setSenhaAtual(e.target.value)}
                  />
                </Box>
              </Stack>

              <Stack>
                <Label
                  number="2"
                  label="Nova senha"
                  subtitle="Informe a senha nova"
                  status={!!novaSenha}
                />
                <Box>
                  <Input
                    type="password"
                    placeholder="Senha nova..."
                    value={novaSenha}
                    onChange={e => setNovaSenha(e.target.value)}
                  />
                </Box>
              </Stack>

              <Stack>
                <Label
                  number="3"
                  label="Confirme a senha"
                  subtitle="Confirme a nova senha"
                  status={
                    !!confirmacaoNovaSenha && confirmacaoNovaSenha === novaSenha
                  }
                />
                <Box>
                  <Input
                    type="password"
                    placeholder="Confirmação da senha..."
                    value={confirmacaoNovaSenha}
                    onChange={e => setConfirmacaoNovaSenha(e.target.value)}
                  />
                </Box>
              </Stack>

              <Footer>
                <Button onClick={alterarMinhaSenha}>SALVAR</Button>
              </Footer>
            </Form>
          </Area>
        </Container>
      </Scroll>
    </>
  );
};

export default InformacoesGerais;
